import {InputText} from '@/components/Form/index.mjs'
import FormItemBizProp from '../components/FormItemBizProp.jsx'
import FormChooseDesign from '../_DESIGN/FormChooseDesign.jsx'
import {FormItemOoName, FormItemOoNo} from '../OO/FormChooseOo.jsx'
import Model from './ModelOr.mjs'

export const FormItemOrName = props => (
    <FormItemBizProp
        Model={Model}
        prop="orName"
        {...props}
    >
        <InputText allowClear />
    </FormItemBizProp>
)

export default function FormChooseOr(props) {
    return (
        <FormChooseDesign {...props}>
            <FormItemOoNo />
            <FormItemOoName />
            <FormItemOrName />
        </FormChooseDesign>
    )
}
